const routeValidation = route => {
  if (!route.startsWith('/')) {
    throw new Error('Please make sure the route starts with /');
  }
};
export const appCatalogUrl = (mpacBaseUrl, route) => {
  routeValidation(route);
  return "".concat(mpacBaseUrl, "/gateway/api/marketplace/catalog").concat(route);
};